// Getters
export const UNREAD_FINANCIAL_BATCHES = 'financial_batch/UNREAD_FINANCIAL_BATCHES'
export const RECENT_FINANCIAL_BATCHES = 'financial_batch/RECENT_FINANCIAL_BATCHES'
export const FINANCIAL_BATCH_ACKNOWLEDGE_MODAL = 'financial_batch/FINANCIAL_BATCH_ACKNOWLEDGE_MODAL'

// Mutations
export const MUTATE_UNREAD_FINANCIAL_BATCHES = 'financial_batch/MUTATE_UNREAD_FINANCIAL_BATCHES'
export const MUTATE_RECENT_FINANCIAL_BATCHES = 'financial_batch/MUTATE_RECENT_FINANCIAL_BATCHES'
export const MUTATE_FINANCIAL_BATCH_ACKNOWLEDGE_MODAL = 'financial_batch/MUTATE_FINANCIAL_BATCH_ACKNOWLEDGE_MODAL'

// Actions
export const GET_UNREAD_FINANCIAL_BATCHES = 'financial_batch/GET_UNREAD_FINANCIAL_BATCHES'
export const GET_RECENT_FINANCIAL_BATCHES = 'financial_batch/GET_RECENT_FINANCIAL_BATCHES'
export const ACKNOWLEDGE_FINANCIAL_BATCH = 'financial_batch/ACKNOWLEDGE_FINANCIAL_BATCH'
export const OPEN_FINANCIAL_BATCH_ACKNOWLEDGE_MODAL = 'financial_batch/OPEN_FINANCIAL_BATCH_ACKNOWLEDGE_MODAL'
export const GET_FINANCIAL_BATCHES_BY_ENTITY = 'financial_batch/GET_FINANCIAL_BATCHES_BY_ENTITY'
